import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataEnvioAvaliacao = (): TabelaColuna => ({
  Chave: 'dataEnvioAvaliacao',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataEnvioAvaliacao)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 90 }}>Data Envio do Trabalho</div>
  )
})
